// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes swing {
  0%, 30%, 50%, 70%, 100% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-5deg);
  }
}
.pro-sidebar {
  color: #adadad;
  height: 100%;
  width: 270px;
  min-width: 270px;
  text-align: left;
  transition: width, left, right, 0.3s;
  position: relative;
  z-index: 1009;
}
.pro-sidebar > .pro-sidebar-inner {
  background: #1d1d1d;
  height: 100%;
  position: relative;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > img.sidebar-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  opacity: 0.3;
  left: 0;
  top: 0;
  z-index: 100;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-header {
  border-bottom: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-content {
  flex-grow: 1;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-footer {
  border-top: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.pro-sidebar .overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: none;
}
.pro-sidebar.collapsed {
  width: 80px;
  min-width: 80px;
}
.pro-sidebar.rtl {
  text-align: right;
  direction: rtl;
}
@media (max-width: 480px) {
  .pro-sidebar.xs {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xs.collapsed {
    left: -80px;
  }
  .pro-sidebar.xs.toggled {
    left: 0;
  }
  .pro-sidebar.xs.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xs.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xs.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xs.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 576px) {
  .pro-sidebar.sm {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.sm.collapsed {
    left: -80px;
  }
  .pro-sidebar.sm.toggled {
    left: 0;
  }
  .pro-sidebar.sm.toggled .overlay {
    display: block;
  }
  .pro-sidebar.sm.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.sm.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.sm.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 768px) {
  .pro-sidebar.md {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.md.collapsed {
    left: -80px;
  }
  .pro-sidebar.md.toggled {
    left: 0;
  }
  .pro-sidebar.md.toggled .overlay {
    display: block;
  }
  .pro-sidebar.md.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.md.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.md.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 992px) {
  .pro-sidebar.lg {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.lg.collapsed {
    left: -80px;
  }
  .pro-sidebar.lg.toggled {
    left: 0;
  }
  .pro-sidebar.lg.toggled .overlay {
    display: block;
  }
  .pro-sidebar.lg.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.lg.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.lg.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1200px) {
  .pro-sidebar.xl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xl.toggled {
    left: 0;
  }
  .pro-sidebar.xl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xl.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1600px) {
  .pro-sidebar.xxl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xxl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xxl.toggled {
    left: 0;
  }
  .pro-sidebar.xxl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xxl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xxl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xxl.rtl.toggled {
    left: auto;
    right: 0;
  }
}

.pro-sidebar .pro-menu.submenu-bullets .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  content: "";
  display: inline-block;
  width: 4px;
  min-width: 4px;
  height: 4px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
  box-shadow: 1px 0px 0px #adadad, 0px -1px 0px #adadad, 0px 1px 0px #adadad, -1px 0px 0px #adadad;
}

.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pro-sidebar .pro-menu {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
  position: relative;
  background-color: rgba(255, 255, 255, 0.05);
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > div > ul {
  padding-top: 15px;
  padding-bottom: 15px;
}
.pro-sidebar .pro-menu a {
  text-decoration: none;
  color: #adadad;
}
.pro-sidebar .pro-menu a:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
}
.pro-sidebar .pro-menu a:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item {
  font-size: 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.active {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item .suffix-wrapper {
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item .prefix-wrapper {
  display: flex;
  margin-right: 5px;
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 35px 8px 20px;
  cursor: pointer;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
  outline: none;
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 10px;
  font-size: 14px;
  width: 35px;
  min-width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  display: inline-block;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper .pro-icon {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  flex-grow: 1;
  flex-shrink: 1;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item:before {
  background: #adadad;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  display: inline-block;
  border-style: solid;
  border-color: #adadad;
  border-width: 0 2px 2px 0;
  padding: 2.5px;
  vertical-align: middle;
  transition: transform 0.3s;
  transform: rotate(-45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item:before {
  background: transparent !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 24px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item > .pro-icon-wrapper {
  background: none;
  width: auto;
  min-width: auto;
  height: auto;
  line-height: auto;
}
.pro-sidebar .pro-menu:not(.inner-submenu-arrows) .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  background-color: rgba(255, 255, 255, 0.05);
}
.pro-sidebar .pro-menu.square .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 0;
}
.pro-sidebar .pro-menu.round .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 4px;
}
.pro-sidebar .pro-menu.circle .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 50%;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .suffix-wrapper,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .prefix-wrapper {
  opacity: 0;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-list-item {
  background-color: rgba(29, 29, 29, 0.95);
  z-index: 111;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item {
  pointer-events: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  height: auto !important;
  position: fixed;
  visibility: hidden;
  min-width: 220px;
  max-width: 270px;
  background-color: transparent;
  max-height: 100%;
  padding-left: 3px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-left: 10px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  max-height: 100vh;
  overflow-y: auto;
  background-color: rgba(29, 29, 29, 0.95);
  padding-left: 20px;
  border-radius: 4px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover > .pro-inner-list-item {
  transition: visibility, transform 0.3s;
  visibility: visible;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item .prefix-wrapper {
  margin-right: 0;
  margin-left: 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item {
  padding: 8px 20px 8px 35px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 0;
  margin-left: 10px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  right: auto;
  left: 20px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(135deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 0;
  padding-right: 24px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 15px 8px 30px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  margin-right: 0;
  margin-left: 15px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  padding-left: 0;
  padding-right: 3px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-right: 10px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  padding-left: 0;
  padding-right: 20px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 5px 8px 30px;
}

.popper-arrow {
  position: absolute;
  z-index: -1;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.popper-element[data-popper-placement^=left] > .popper-arrow {
  right: 0;
  border-right: 7px solid rgba(29, 29, 29, 0.95);
}

.popper-element[data-popper-placement^=right] > .popper-arrow {
  left: 0;
  border-left: 7px solid rgba(29, 29, 29, 0.95);
}

.react-slidedown {
  height: 0;
  transition-property: none;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.react-slidedown.transitioning {
  overflow-y: hidden;
}

.react-slidedown.closed {
  display: none;
}

body {
  margin: 0;
  height: 100vh;
  color: #353535;
  font-family: "Roboto", sans-serif;
}

#root {
  height: 100%;
}

.app {
  height: 100%;
  display: flex;
  position: relative;
}
.app .btn-toggle {
  cursor: pointer;
  width: 35px;
  height: 35px;
  background: #353535;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}
.app .sidebar-btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.app .sidebar-btn-wrapper .sidebar-btn {
  padding: 1px 15px;
  border-radius: 40px;
  background: rgba(255, 255, 255, 0.05);
  color: #adadad;
  text-decoration: none;
  margin: 0 auto;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
}
.app .sidebar-btn-wrapper .sidebar-btn span {
  margin-left: 5px;
  font-size: 13px;
}
.app .sidebar-btn-wrapper .sidebar-btn:hover {
  color: #d8d8d8;
}
.app .collapsed .sidebar-btn {
  display: inline-block;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  line-height: 40px;
  padding: 0;
}
.app main {
  padding: 24px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.app main header {
  margin-bottom: 40px;
  border-bottom: 1px solid #efefef;
}
.app main header h1 {
  display: flex;
  align-items: center;
  transform: translateX(-20px);
}
.app main footer {
  margin-top: auto;
  color: #888;
  text-align: center;
}
.app main footer a {
  text-decoration: none;
  color: #888;
}
.app main footer a:hover {
  text-decoration: underline;
}
.app .social-bagdes {
  margin-top: 10px;
}
.app .social-bagdes img {
  margin: 5px;
}
.app .block {
  display: flex;
  margin-bottom: 24px;
  font-size: 14px;
  color: #545454;
}
.app .block > span {
  margin-left: 10px;
}
.app.rtl {
  direction: rtl;
  text-align: right;
}
.app.rtl header h1 {
  transform: translateX(20px);
}
.app.rtl .block {
  direction: rtl;
}
.app.rtl .block > span {
  margin-left: 0;
  margin-right: 10px;
}
.app.rtl .sidebar-btn-wrapper .sidebar-btn span {
  margin-left: 0;
  margin-right: 5px;
}
@media (max-width: 767.98px) {
  .app {
    overflow-x: hidden;
  }
  .app header h1 {
    font-size: 24px;
  }
}
@media (max-width: 768px) {
  .app .btn-toggle {
    display: flex;
  }
  .app.rtl .btn-toggle {
    margin-left: auto;
  }
}

.badge {
  padding: 3px 6px;
  font-size: 9px;
  letter-spacing: 1px;
  border-radius: 15px;
}
.badge.red {
  color: #ffffff;
  background: #d63030;
}
.badge.gray {
  color: #ffffff;
  background: #777777;
}
.badge.yellow {
  color: #000000;
  background: #ffd331;
}

.pro-sidebar-layout::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.pro-sidebar-layout {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.pro-item-content {
  -webkit-user-select: none;
          user-select: none;
}

.custom_scrollbar {
  overflow-y: hidden;
  overflow-x: scroll;
}

.custom_scrollbar::-webkit-scrollbar {
  height: 6px;
}

.custom_scrollbar::-webkit-scrollbar-button {
  background: #ccc;
}

.custom_scrollbar::-webkit-scrollbar-track-piece {
  background: #f2f2f2;
}

.custom_scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #ccc;
}`, "",{"version":3,"sources":["webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_animation.scss","webpack://./src/pages/private/Dashboard/SideBar/styles/App.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_sidebar.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/variables.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_menu.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_popperArrow.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_reactSlidedown.scss"],"names":[],"mappings":"AAAA;EACE;IAKE,uBAAA;ECFF;EDKA;IACE,wBAAA;ECHF;EDMA;IACE,yBAAA;ECJF;EDOA;IACE,uBAAA;ECLF;EDQA;IACE,wBAAA;ECNF;AACF;ACSA;EACE,cDtBc;ECuBd,YAAA;EACA,YC3Bc;ED4Bd,gBC5Bc;ED6Bd,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;ADPF;ACQE;EACE,mBDlCe;ECmCf,YAAA;EACA,kBAAA;EACA,YAAA;ADNJ;ACQI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;ADNN;ACSI;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ADPN;ACSM;EACE,iDAAA;ADPR;ACSM;EACE,YAAA;ADPR;ACSM;EACE,8CAAA;ADPR;ACSM;EACE,qBAAA;EACA,UAAA;EACA,SAAA;ADPR;ACYE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;ADVJ;ACaE;EACE,WCxFsB;EDyFtB,eCzFsB;AF8E1B;ACcE;EACE,iBAAA;EACA,cAAA;ADZJ;ACgBI;EADF;IAnGA,eAAA;IACA,YAAA;EDwFA;ECvFA;IACE,WAAA;EDyFF;ECvFA;IACE,OAAA;EDyFF;ECxFE;IACE,cAAA;ED0FJ;ECvFA;IACE,UAAA;IACA,aAAA;EDyFF;ECxFE;IACE,UAAA;IACA,YAAA;ED0FJ;ECxFE;IACE,UAAA;IACA,QAAA;ED0FJ;AACF;ACNI;EADF;IAxGA,eAAA;IACA,YAAA;EDmHA;EClHA;IACE,WAAA;EDoHF;EClHA;IACE,OAAA;EDoHF;ECnHE;IACE,cAAA;EDqHJ;EClHA;IACE,UAAA;IACA,aAAA;EDoHF;ECnHE;IACE,UAAA;IACA,YAAA;EDqHJ;ECnHE;IACE,UAAA;IACA,QAAA;EDqHJ;AACF;AC5BI;EADF;IA7GA,eAAA;IACA,YAAA;ED8IA;EC7IA;IACE,WAAA;ED+IF;EC7IA;IACE,OAAA;ED+IF;EC9IE;IACE,cAAA;EDgJJ;EC7IA;IACE,UAAA;IACA,aAAA;ED+IF;EC9IE;IACE,UAAA;IACA,YAAA;EDgJJ;EC9IE;IACE,UAAA;IACA,QAAA;EDgJJ;AACF;AClDI;EADF;IAlHA,eAAA;IACA,YAAA;EDyKA;ECxKA;IACE,WAAA;ED0KF;ECxKA;IACE,OAAA;ED0KF;ECzKE;IACE,cAAA;ED2KJ;ECxKA;IACE,UAAA;IACA,aAAA;ED0KF;ECzKE;IACE,UAAA;IACA,YAAA;ED2KJ;ECzKE;IACE,UAAA;IACA,QAAA;ED2KJ;AACF;ACxEI;EADF;IAvHA,eAAA;IACA,YAAA;EDoMA;ECnMA;IACE,WAAA;EDqMF;ECnMA;IACE,OAAA;EDqMF;ECpME;IACE,cAAA;EDsMJ;ECnMA;IACE,UAAA;IACA,aAAA;EDqMF;ECpME;IACE,UAAA;IACA,YAAA;EDsMJ;ECpME;IACE,UAAA;IACA,QAAA;EDsMJ;AACF;AC9FI;EADF;IA5HA,eAAA;IACA,YAAA;ED+NA;EC9NA;IACE,WAAA;EDgOF;EC9NA;IACE,OAAA;EDgOF;EC/NE;IACE,cAAA;EDiOJ;EC9NA;IACE,UAAA;IACA,aAAA;EDgOF;EC/NE;IACE,UAAA;IACA,YAAA;EDiOJ;EC/NE;IACE,UAAA;IACA,QAAA;EDiOJ;AACF;;AGtPE;EACE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gGAAA;AHyPJ;;AGpPA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AHuPF;;AGnPE;EACE,iBAAA;EACA,oBAAA;AHsPJ;AGlPQ;EACE,kBAAA;EACA,2CH5BS;AAgRnB;AGlPU;EACE,iBAAA;EACA,oBAAA;AHoPZ;AG/OI;EACE,qBAAA;EACA,cHrCU;AAsRhB;AGhPM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;AHkPR;AGhPM;EACE,cH/CU;AAiSlB;AG/OI;EACE,eAAA;AHiPN;AGhPM;EACE,cHrDU;AAuSlB;AG/OM;EACE,UAAA;EACA,wBAAA;AHiPR;AG/OM;EACE,aAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;AHiPR;AG9OM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AHgPR;AG9OQ;EACE,aAAA;EACA,cH5EQ;AA4TlB;AG9OQ;EACE,kBAAA;EACA,eAAA;EACA,WH/EE;EGgFF,eHhFE;EGiFF,YHjFE;EGkFF,iBHlFE;EGmFF,kBAAA;EACA,qBAAA;AHgPV;AG9OU;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AHgPZ;AG5OQ;EACE,YAAA;EACA,cAAA;AH8OV;AGzOQ;EACE,cHxGQ;AAmVlB;AGzOY;EACE,6CAAA;AH2Od;AGnOU;EACE,mBHrHI;AA0VhB;AGlOU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AHoOZ;AGlOY;EACE,qBAAA;EACA,mBAAA;EACA,qBHjIE;EGkIF,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AHoOd;AG7NY;EACE,kCAAA;AH+Nd;AG5Nc;EACE,wBAAA;AH8NhB;AGxNQ;EACE,kBDrJO;AF+WjB;AGxNU;EACE,0BAAA;AH0NZ;AGxNY;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AH0Nd;AGlNM;EACE,aAAA;AHoNR;AGxMU;EACE,2CHvLI;AAiYhB;AGjMU;EACE,gBAAA;AHmMZ;AG3LU;EACE,kBAAA;AH6LZ;AGrLU;EACE,kBAAA;AHuLZ;AGzKY;;EAEE,UAAA;AH2Kd;AGxKU;EACE,wCH1OiB;EG2OjB,YAAA;AH0KZ;AGnLQ;EAWE,kBAAA;AH2KV;AG1KU;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AH4KZ;AG1KU;EACE,kBAAA;AH4KZ;AG1KY;EACE,oBAAA;AH4Kd;AG1Kc;EACE,aAAA;AH4KhB;AGzKY;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AH2Kd;AG1Kc;EACE,kBAAA;AH4KhB;AG1Kc;EACE,iBAAA;EACA,gBAAA;EACA,wCHjRa;EGkRb,kBAAA;EACA,kBAAA;AH4KhB;AGxKc;EACE,sCAAA;EACA,mBAAA;AH0KhB;AGvKgB;EACE,6CAAA;AHyKlB;AGnKc;;EAEE,yBAAA;AHqKhB;AGxJQ;EACE,eAAA;EACA,gBAAA;AH0JV;AGxJQ;EACE,0BAAA;AH0JV;AGzJU;EACE,eAAA;EACA,iBAAA;AH2JZ;AGrJY;EACE,WAAA;EACA,UAAA;AHuJd;AGtJc;EACE,yBAAA;AHwJhB;AGjJgB;EACE,wBAAA;AHmJlB;AG7IU;EACE,eAAA;EACA,mBD/UK;AF8djB;AG7IY;EACE,0BAAA;AH+Id;AG9Ic;EACE,eAAA;EACA,iBAAA;AHgJhB;AGlIc;EACE,eAAA;EACA,kBAAA;AHoIhB;AGnIgB;EACE,mBAAA;AHqIlB;AGnIgB;EACE,eAAA;EACA,mBAAA;AHqIlB;AGhIgB;;EAEE,yBAAA;AHkIlB;;AI7fA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;AJggBF;;AI7fA;EACE,QAAA;EACA,8CAAA;AJggBF;;AI7fA;EACE,OAAA;EACA,6CAAA;AJggBF;;AKhhBA;EACE,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,uCAAA;ALmhBF;;AKhhBA;EACE,kBAAA;ALmhBF;;AKhhBA;EACE,aAAA;ALmhBF;;AAphBA;EACE,SAAA;EACA,aAAA;EACA,cAAA;EACA,iCAAA;AAuhBF;;AAphBA;EACE,YAAA;AAuhBF;;AAnhBA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AAshBF;AAphBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAshBJ;AAnhBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAqhBJ;AAphBI;EACE,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;AAshBN;AArhBM;EACE,gBAAA;EACA,eAAA;AAuhBR;AArhBM;EACE,cA1DU;AAilBlB;AAjhBI;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;AAmhBN;AA/gBE;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAihBJ;AAhhBI;EACE,mBAAA;EACA,gCAAA;AAkhBN;AAjhBM;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;AAmhBR;AA/gBI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AAihBN;AAhhBM;EACE,qBAAA;EACA,WAAA;AAkhBR;AAjhBQ;EACE,0BAAA;AAmhBV;AA9gBE;EACE,gBAAA;AAghBJ;AA/gBI;EACE,WAAA;AAihBN;AA7gBE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AA+gBJ;AA9gBI;EACE,iBAAA;AAghBN;AA5gBE;EACE,cAAA;EACA,iBAAA;AA8gBJ;AA3gBM;EACE,2BAAA;AA6gBR;AA1gBI;EACE,cAAA;AA4gBN;AA3gBM;EACE,cAAA;EACA,kBAAA;AA6gBR;AAxgBQ;EACE,cAAA;EACA,iBAAA;AA0gBV;AApgBE;EAjIF;IAkII,kBAAA;EAugBF;EArgBI;IACE,eAAA;EAugBN;AACF;AApgBE;EACE;IACE,aAAA;EAsgBJ;EAlgBI;IACE,iBAAA;EAogBN;AACF;;AA/fA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAkgBF;AAjgBE;EACE,cAAA;EACA,mBAAA;AAmgBJ;AAjgBE;EACE,cAAA;EACA,mBAAA;AAmgBJ;AAjgBE;EACE,cAAA;EACA,mBAAA;AAmgBJ;;AA9fA;EACE,aAAA;AAigBF;;AA9fA,4CAAA;AACA;EACE,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AAigBF;;AA9fA;EACE,yBAAA;UAAA,iBAAA;AAigBF;;AA9fA;EACE,kBAAA;EACA,kBAAA;AAigBF;;AA9fA;EACE,WAAA;AAigBF;;AA7fA;EACE,gBAAA;AAggBF;;AA9fA;EACE,mBAAA;AAigBF;;AA/fA;EACE,mBAAA;EACA,oDAAA;EACA,sBAAA;AAkgBF","sourcesContent":["@keyframes swing {\n  0%,\n  30%,\n  50%,\n  70%,\n  100% {\n    transform: rotate(0deg);\n  }\n\n  10% {\n    transform: rotate(10deg);\n  }\n\n  40% {\n    transform: rotate(-10deg);\n  }\n\n  60% {\n    transform: rotate(5deg);\n  }\n\n  80% {\n    transform: rotate(-5deg);\n  }\n}\n","@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');\n\n$sidebar-bg-color: #1d1d1d;\n$submenu-bg-color: rgba(255, 255, 255, 0.05);\n$submenu-bg-color-collapsed: rgba(29, 29, 29, 0.95);\n$sidebar-color: #adadad;\n$highlight-color: #d8d8d8;\n$icon-bg-color: rgba(255, 255, 255, 0.05);\n$icon-size: 35px;\n\n@import 'react-pro-sidebar/dist/scss/styles.scss';\nbody {\n  margin: 0;\n  height: 100vh;\n  color: #353535;\n  font-family: 'Roboto', sans-serif;\n}\n\n#root {\n  height: 100%;\n}\n\n\n.app {\n  height: 100%;\n  display: flex;\n  position: relative;\n\n  .btn-toggle {\n    cursor: pointer;\n    width: 35px;\n    height: 35px;\n    background: #353535;\n    color: #fff;\n    text-align: center;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n  }\n\n  .sidebar-btn-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .sidebar-btn {\n      padding: 1px 15px;\n      border-radius: 40px;\n      background: rgba(255, 255, 255, 0.05);\n      color: #adadad;\n      text-decoration: none;\n      margin: 0 auto;\n      height: 35px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      span {\n        margin-left: 5px;\n        font-size: 13px;\n      }\n      &:hover {\n        color: $highlight-color;\n      }\n    }\n  }\n\n  .collapsed {\n    .sidebar-btn {\n      display: inline-block;\n      border-radius: 50%;\n      width: 35px;\n      height: 35px;\n      line-height: 40px;\n      padding: 0;\n    }\n  }\n\n  main {\n    padding: 24px;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    header {\n      margin-bottom: 40px;\n      border-bottom: 1px solid #efefef;\n      h1 {\n        display: flex;\n        align-items: center;\n        transform: translateX(-20px);\n      }\n    }\n\n    footer {\n      margin-top: auto;\n      color: #888;\n      text-align: center;\n      a {\n        text-decoration: none;\n        color: #888;\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n  .social-bagdes {\n    margin-top: 10px;\n    img {\n      margin: 5px;\n    }\n  }\n\n  .block {\n    display: flex;\n    margin-bottom: 24px;\n    font-size: 14px;\n    color: #545454;\n    > span {\n      margin-left: 10px;\n    }\n  }\n\n  &.rtl {\n    direction: rtl;\n    text-align: right;\n\n    header {\n      h1 {\n        transform: translateX(20px);\n      }\n    }\n    .block {\n      direction: rtl;\n      > span {\n        margin-left: 0;\n        margin-right: 10px;\n      }\n    }\n    .sidebar-btn-wrapper {\n      .sidebar-btn {\n        span {\n          margin-left: 0;\n          margin-right: 5px;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 767.98px) {\n    overflow-x: hidden;\n    header {\n      h1 {\n        font-size: 24px;\n      }\n    }\n  }\n  @media (max-width: $breakpoint-md) {\n    .btn-toggle {\n      display: flex;\n    }\n\n    &.rtl {\n      .btn-toggle {\n        margin-left: auto;\n      }\n    }\n  }\n}\n\n.badge {\n  padding: 3px 6px;\n  font-size: 9px;\n  letter-spacing: 1px;\n  border-radius: 15px;\n  &.red {\n    color: #ffffff;\n    background: #d63030;\n  }\n  &.gray {\n    color: #ffffff;\n    background: #777777;\n  }\n  &.yellow {\n    color: #000000;\n    background: #ffd331;\n  }\n}\n\n\n.pro-sidebar-layout::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.pro-sidebar-layout {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\n.pro-item-content{\n  user-select: none;\n}\n\n.custom_scrollbar{\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.custom_scrollbar::-webkit-scrollbar{\n  height: 6px;\n  \n}\n\n.custom_scrollbar::-webkit-scrollbar-button {\n  background: #ccc;\n}\n.custom_scrollbar::-webkit-scrollbar-track-piece {\n  background: #f2f2f2;\n}\n.custom_scrollbar::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);\n  background-color: #ccc;\n}","@mixin break-point {\n  position: fixed;\n  left: -$sidebar-width;\n  &.collapsed {\n    left: -$sidebar-collapsed-width;\n  }\n  &.toggled {\n    left: 0;\n    .overlay {\n      display: block;\n    }\n  }\n  &.rtl {\n    left: auto;\n    right: -$sidebar-width;\n    &.collapsed {\n      left: auto;\n      right: -$sidebar-collapsed-width;\n    }\n    &.toggled {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n.pro-sidebar {\n  color: $sidebar-color;\n  height: 100%;\n  width: $sidebar-width;\n  min-width: $sidebar-width;\n  text-align: left;\n  transition: width, left, right, 0.3s;\n  position: relative;\n  z-index: 1009;\n  > .pro-sidebar-inner {\n    background: $sidebar-bg-color;\n    height: 100%;\n    position: relative;\n    z-index: 101;\n\n    > img.sidebar-bg {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n      position: absolute;\n      opacity: 0.3;\n      left: 0;\n      top: 0;\n      z-index: 100;\n    }\n\n    > .pro-sidebar-layout {\n      height: 100%;\n      overflow-y: auto;\n      overflow-x: hidden;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      z-index: 101;\n\n      .pro-sidebar-header {\n        border-bottom: 1px solid rgba($sidebar-color, 0.2);\n      }\n      .pro-sidebar-content {\n        flex-grow: 1;\n      }\n      .pro-sidebar-footer {\n        border-top: 1px solid rgba($sidebar-color, 0.2);\n      }\n      ul {\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n      }\n    }\n  }\n\n  .overlay {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(#000, 0.3);\n    z-index: 100;\n    display: none;\n  }\n\n  &.collapsed {\n    width: $sidebar-collapsed-width;\n    min-width: $sidebar-collapsed-width;\n  }\n\n  &.rtl {\n    text-align: right;\n    direction: rtl;\n  }\n\n  &.xs {\n    @media (max-width: $breakpoint-xs) {\n      @include break-point;\n    }\n  }\n  &.sm {\n    @media (max-width: $breakpoint-sm) {\n      @include break-point;\n    }\n  }\n  &.md {\n    @media (max-width: $breakpoint-md) {\n      @include break-point;\n    }\n  }\n  &.lg {\n    @media (max-width: $breakpoint-lg) {\n      @include break-point;\n    }\n  }\n  &.xl {\n    @media (max-width: $breakpoint-xl) {\n      @include break-point;\n    }\n  }\n  &.xxl {\n    @media (max-width: $breakpoint-xxl) {\n      @include break-point;\n    }\n  }\n}\n","$sidebar-bg-color: #1d1d1d !default;\n$sidebar-color: #adadad !default;\n$sidebar-width: 270px !default;\n$sidebar-collapsed-width: 80px !default;\n$highlight-color: #d8d8d8 !default;\n$submenu-bg-color: #2b2b2b !default;\n$submenu-bg-color-collapsed: #2b2b2b !default;\n$icon-bg-color: #2b2b2b !default;\n$icon-size: 35px !default;\n$submenu-indent: 24px !default;\n\n$breakpoint-xs: 480px !default;\n$breakpoint-sm: 576px !default;\n$breakpoint-md: 768px !default;\n$breakpoint-lg: 992px !default;\n$breakpoint-xl: 1200px !default;\n$breakpoint-xxl: 1600px !default;\n","%pro-item-prefix {\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 4px;\n    min-width: 4px;\n    height: 4px;\n    border: 1px solid $submenu-bg-color;\n    border-radius: 50%;\n    margin-right: 15px;\n    position: relative;\n    box-shadow: 1px 0px 0px $sidebar-color, 0px -1px 0px $sidebar-color, 0px 1px 0px $sidebar-color,\n      -1px 0px 0px $sidebar-color;\n  }\n}\n\n%text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pro-sidebar {\n  .pro-menu {\n    padding-top: 10px;\n    padding-bottom: 10px;\n\n    > ul {\n      > .pro-sub-menu {\n        > .pro-inner-list-item {\n          position: relative;\n          background-color: $submenu-bg-color;\n\n          > div > ul {\n            padding-top: 15px;\n            padding-bottom: 15px;\n          }\n        }\n      }\n    }\n    a {\n      text-decoration: none;\n      color: $sidebar-color;\n      &:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: transparent;\n      }\n      &:hover {\n        color: $highlight-color;\n      }\n    }\n    .pro-menu-item {\n      font-size: 15px;\n      &.active {\n        color: $highlight-color;\n      }\n\n      .suffix-wrapper {\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n      .prefix-wrapper {\n        display: flex;\n        margin-right: 5px;\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n\n      > .pro-inner-item {\n        position: relative;\n        display: flex;\n        align-items: center;\n        padding: 8px 35px 8px 20px;\n        cursor: pointer;\n\n        &:focus {\n          outline: none;\n          color: $highlight-color;\n        }\n        > .pro-icon-wrapper {\n          margin-right: 10px;\n          font-size: 14px;\n          width: $icon-size;\n          min-width: $icon-size;\n          height: $icon-size;\n          line-height: $icon-size;\n          text-align: center;\n          display: inline-block;\n\n          .pro-icon {\n            display: flex;\n            height: 100%;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n\n        > .pro-item-content {\n          flex-grow: 1;\n          flex-shrink: 1;\n\n          @extend %text-truncate;\n        }\n\n        &:hover {\n          color: $highlight-color;\n          .pro-icon-wrapper {\n            .pro-icon {\n              animation: swing ease-in-out 0.5s 1 alternate;\n            }\n          }\n        }\n      }\n\n      &.pro-sub-menu {\n        > .pro-inner-item {\n          &:before {\n            background: $sidebar-color;\n          }\n\n          > .pro-arrow-wrapper {\n            position: absolute;\n            right: 20px;\n            top: 50%;\n            transform: translateY(-50%);\n\n            .pro-arrow {\n              display: inline-block;\n              border-style: solid;\n              border-color: $sidebar-color;\n              border-width: 0 2px 2px 0;\n              padding: 2.5px;\n              vertical-align: middle;\n              transition: transform 0.3s;\n              transform: rotate(-45deg);\n            }\n          }\n        }\n\n        &.open {\n          > .pro-inner-item {\n            &:before {\n              background: transparent !important;\n            }\n            > .pro-arrow-wrapper {\n              .pro-arrow {\n                transform: rotate(45deg);\n              }\n            }\n          }\n        }\n\n        .pro-inner-list-item {\n          padding-left: $submenu-indent;\n\n          .pro-inner-item {\n            padding: 8px 30px 8px 15px;\n\n            > .pro-icon-wrapper {\n              background: none;\n              width: auto;\n              min-width: auto;\n              height: auto;\n              line-height: auto;\n            }\n          }\n        }\n      }\n    }\n\n    &:not(.inner-submenu-arrows) {\n      .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {\n        display: none;\n      }\n    }\n    &.submenu-bullets {\n      .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {\n        @extend %pro-item-prefix;\n      }\n    }\n\n    &.shaped {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            background-color: $icon-bg-color;\n          }\n        }\n      }\n    }\n\n    &.square {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 0;\n          }\n        }\n      }\n    }\n    &.round {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 4px;\n          }\n        }\n      }\n    }\n    &.circle {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 50%;\n          }\n        }\n      }\n    }\n  }\n\n  // styling when the sidebar is collapsed\n\n  &.collapsed {\n    .pro-menu {\n      > ul {\n        > .pro-menu-item {\n          > .pro-inner-item {\n            > .suffix-wrapper,\n            > .prefix-wrapper {\n              opacity: 0;\n            }\n          }\n          > .pro-inner-list-item {\n            background-color: $submenu-bg-color-collapsed;\n            z-index: 111;\n          }\n          position: relative;\n          &::before {\n            content: '';\n            display: inline-block;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            cursor: pointer;\n          }\n          &.pro-sub-menu {\n            position: relative;\n\n            > .pro-inner-item {\n              pointer-events: none;\n\n              > .pro-arrow-wrapper {\n                display: none;\n              }\n            }\n            > .pro-inner-list-item {\n              height: auto !important;\n              position: fixed;\n              visibility: hidden;\n              min-width: 220px;\n              max-width: 270px;\n              background-color: transparent;\n              max-height: 100%;\n              padding-left: 3px;\n              &.has-arrow {\n                padding-left: 10px;\n              }\n              > .popper-inner {\n                max-height: 100vh;\n                overflow-y: auto;\n                background-color: $submenu-bg-color-collapsed;\n                padding-left: 20px;\n                border-radius: 4px;\n              }\n            }\n            &:hover {\n              > .pro-inner-list-item {\n                transition: visibility, transform 0.3s;\n                visibility: visible;\n              }\n              .pro-icon-wrapper {\n                .pro-icon {\n                  animation: swing ease-in-out 0.5s 1 alternate;\n                }\n              }\n            }\n\n            .pro-inner-list-item {\n              .pro-sub-menu-item,\n              .pro-inner-item {\n                padding: 8px 30px 8px 5px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // styles for rtl\n  &.rtl {\n    .pro-menu {\n      .pro-menu-item {\n        .prefix-wrapper {\n          margin-right: 0;\n          margin-left: 5px;\n        }\n        > .pro-inner-item {\n          padding: 8px 20px 8px 35px;\n          > .pro-icon-wrapper {\n            margin-right: 0;\n            margin-left: 10px;\n          }\n        }\n\n        &.pro-sub-menu {\n          > .pro-inner-item {\n            > .pro-arrow-wrapper {\n              right: auto;\n              left: 20px;\n              .pro-arrow {\n                transform: rotate(135deg);\n              }\n            }\n          }\n          &.open {\n            > .pro-inner-item {\n              > .pro-arrow-wrapper {\n                .pro-arrow {\n                  transform: rotate(45deg);\n                }\n              }\n            }\n          }\n\n          .pro-inner-list-item {\n            padding-left: 0;\n            padding-right: $submenu-indent;\n\n            .pro-inner-item {\n              padding: 8px 15px 8px 30px;\n              &:before {\n                margin-right: 0;\n                margin-left: 15px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // styles for rtl and collapsed\n    &.collapsed {\n      .pro-menu {\n        > ul {\n          > .pro-menu-item {\n            &.pro-sub-menu {\n              > .pro-inner-list-item {\n                padding-left: 0;\n                padding-right: 3px;\n                &.has-arrow {\n                  padding-right: 10px;\n                }\n                > .popper-inner {\n                  padding-left: 0;\n                  padding-right: 20px;\n                }\n              }\n\n              .pro-inner-list-item {\n                .pro-sub-menu-item,\n                .pro-inner-item {\n                  padding: 8px 5px 8px 30px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".popper-arrow {\n  position: absolute;\n  z-index: -1;\n  width: 0;\n  height: 0;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.popper-element[data-popper-placement^='left'] > .popper-arrow {\n  right: 0;\n  border-right: 7px solid $submenu-bg-color-collapsed;\n}\n\n.popper-element[data-popper-placement^='right'] > .popper-arrow {\n  left: 0;\n  border-left: 7px solid $submenu-bg-color-collapsed;\n}\n",".react-slidedown {\n  height: 0;\n  transition-property: none;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n.react-slidedown.transitioning {\n  overflow-y: hidden;\n}\n\n.react-slidedown.closed {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
